import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { uploadInjectionKey as r } from "./interface.js";
import t from "../../progress/src/Progress.js";
import s from "../../_internal/fade-in-expand-transition/src/FadeInExpandTransition.js";
import { defineComponent as o, inject as n, h as e } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const u = o({
  name: "UploadProgress",
  props: {
    show: Boolean,
    percentage: {
      type: Number,
      required: !0
    },
    status: {
      type: String,
      required: !0
    }
  },
  setup() {
    return {
      mergedTheme: n(r).mergedThemeRef
    };
  },
  render() {
    return e(s, null, {
      default: () => this.show ? e(t, {
        type: "line",
        showIndicator: !1,
        percentage: this.percentage,
        status: this.status,
        height: 2,
        theme: this.mergedTheme.peers.Progress,
        themeOverrides: this.mergedTheme.peerOverrides.Progress
      }) : null
    });
  }
});
export {
  u as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/upload/src/UploadProgress.js
// module id = 1723
// module chunks = 41